var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3723_3049)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5674,
    cy: 19.1338,
    r: 17.85,
    fill: "white",
    stroke: "#FD8238",
    strokeWidth: 1.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0385 24.2587C11.4834 24.2587 10.9665 24.1581 10.4877 23.9568C10.0089 23.7556 9.58914 23.4746 9.22832 23.1138C8.8675 22.753 8.58648 22.3297 8.38525 21.844C8.18403 21.3583 8.08342 20.8274 8.08342 20.2515C8.08342 19.6756 8.18056 19.1448 8.37485 18.6591C8.56913 18.1664 8.84321 17.7432 9.19709 17.3893C9.55097 17.0285 9.96383 16.7509 10.4357 16.5566C10.9144 16.3554 11.4349 16.2548 11.9969 16.2548C12.5589 16.2548 13.062 16.3485 13.5061 16.5358C13.9571 16.7231 14.3387 16.9729 14.651 17.2852C14.9632 17.5974 15.1853 17.9444 15.3171 18.326L13.8912 19.013C13.7594 18.6383 13.5269 18.3295 13.1938 18.0866C12.8677 17.8368 12.4687 17.7119 11.9969 17.7119C11.5389 17.7119 11.1365 17.8195 10.7895 18.0346C10.4426 18.2497 10.172 18.5481 9.97771 18.9297C9.79036 19.3044 9.69669 19.745 9.69669 20.2515C9.69669 20.7581 9.7973 21.2021 9.99853 21.5838C10.1998 21.9654 10.4738 22.2638 10.8208 22.4789C11.1747 22.694 11.5806 22.8015 12.0385 22.8015C12.3924 22.8015 12.722 22.7356 13.0273 22.6038C13.3396 22.465 13.5894 22.2673 13.7767 22.0105C13.971 21.7538 14.0681 21.445 14.0681 21.0842V20.4389L14.8071 21.0634H11.9969V19.7103H15.6814V20.5326C15.6814 21.164 15.5773 21.7156 15.3692 22.1875C15.161 22.6524 14.88 23.0409 14.5261 23.3532C14.1792 23.6585 13.7871 23.8875 13.35 24.0401C12.9198 24.1858 12.4826 24.2587 12.0385 24.2587ZM16.6776 24.1338V16.3797H18.2388L21.1427 20.2307H20.4141L23.2347 16.3797H24.796V24.1338H23.1827V18.1595L23.828 18.3052L20.8409 22.1562H20.6327L17.7496 18.3052L18.2909 18.1595V24.1338H16.6776ZM27.5657 24.1338V17.7848H25.5985V16.3797H31.1149V17.7848H29.179V24.1338H27.5657Z",
    fill: "#FD8238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3723_3049",
    x: -0.000162661,
    y: -0.0000813305,
    width: 39.4349,
    height: 39.4349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.433675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.433675
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3723_3049"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3723_3049",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmtLogo);
export default __webpack_public_path__ + "static/media/gmt-logo.088bf4fd83ace9c074c7b82d1c88dec9.svg";
export { ForwardRef as ReactComponent };